/**
 * The "MainArea" in the Banner/Main/Footer model via flexbox
 */

import React, { PropsWithChildren } from 'react';
export function MainArea({ children }: PropsWithChildren<{}>) {
  return <div className="flex-grow">{children}</div>;
}
